// Flow types automatically removed

import slugify from 'dibs-slugify/exports/slugify';
export const types = {
    CATALOG: 'CATALOG',
    FOLDERS: 'FOLDERS',
    ITEMS: 'ITEMS',
    PDP: 'PDP',
    INVOICE: 'INVOICE',
    DESIGN_PROFILE: 'DESIGN_PROFILE',
    CURATED_FOLDER: 'CURATED_FOLDER',
};
export const typesRequiringName = [
    types.CATALOG,
    types.FOLDERS,
    types.ITEMS,
    types.PDP,
    types.DESIGN_PROFILE,
    types.CURATED_FOLDER,
];
export const mutations = {
    responses: {
        ERROR: 'error',
        COMPLETE: 'complete',
        LOADING: 'loading',
        NULL: 'nullState',
        SUCCESS: 'success',
    },
    types: {
        SHARE: 'SHARE',
    },
};
export const slugifyFolderLink = (portfolioName = '', portfolioId = '') => {
    // Only allow dashes and alphanumeric characters in url label
    const folderType = types.FOLDERS.toLowerCase();
    const portName = slugify(portfolioName);

    if (portName) {
        return `/${folderType}/${portName}/${portfolioId}/`;
    }

    return `/${folderType}/${portfolioId}/`;
};
export const getFolderLink = (portfolioName = '', portfolioId = '') => {
    return `${
        typeof location !== 'undefined' ? location.origin : 'https://www.1stdibs.com'
    }/favorites${slugifyFolderLink(portfolioName, portfolioId)}`;
};
export const getInvoiceLink = (transactionId = '', invoiceAccessToken = '') =>
    `${
        typeof location !== 'undefined' ? location.origin : 'https://www.1stdibs.com'
    }/orders/invoice/share/${transactionId}?shareToken=${invoiceAccessToken}`;
